import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { appointementInit , appointementClearHours , appointementSave , timeInfo} from "../actions/appointement";
import 'react-day-picker/lib/style.css';
import DayPicker , { DateUtils } from 'react-day-picker';
import moment from "moment";
import 'moment/locale/fr';

import { stepIncrement } from "../actions/step";

// const modifiers = {
//   disabled: { daysOfWeek: [0,6] }
// };

const MONTHS = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];

const WEEKDAYS_LONG = [
  'Dimanche',
  'Lundi',
  'Mardi',
  'Mercredi',
  'Jeudi',
  'Vendredi',
  'Samedi',
];

const WEEKDAYS_SHORT = ['DIM', 'LUN', 'MAR', 'MER', 'JEU', 'VEN', 'SAM'];

const actualYear = Number(moment().format('YYYY'));
const actualMonth = Number(moment().format('M'));
const actualDay = Number(moment().format('D'));

const dataDays = {
  wlName: "seat",
  locale: "fr",
  employee: -1,
  month: 0,
  year: 0,
  origin: "api_erdv",
  places: 1
}

const dataHours = {
  wlName: "seat",
  date: undefined,
  places: 1,
  employee:  -1
}

function formatNumber(number) {
  return (number < 10 ? '0' : '') + number;
}

function upper(data) {
  return data.charAt(0).toUpperCase() + data.substr(1);
}

class ClassCalendar extends Component {
  constructor(props) {
    super(props);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.disableDays = this.disableDays.bind(this);
    this.state = {
      selectedDay: new Date(actualYear, actualMonth - 1 , actualDay),
      selectedMonth: actualMonth - 1,
      selectedYear: actualYear
    };
    this.handleClick = this.handleClick.bind(this);
  }
  componentDidMount() {
    dataDays["proId"] = this.props.restIntel.intel.dealerInfo.id;
    dataDays["templates"] = this.props.restIntel.intel.dealerInfo.template;

    dataHours["proId"] = this.props.restIntel.intel.dealerInfo.id;
    dataHours["templates"] = this.props.restIntel.intel.dealerInfo.template;

    dataDays["month"] = this.state.selectedMonth;
    dataDays["year"] = this.state.selectedYear;
    this.props.appointementInit('AvailableBookingTimeSlotsForMonth' ,  dataDays , 'dealerDays');
    //TRACKING
    var iframeData = ['setVirtualPage', 'rdv-en-ligne/date_and_time_choice'];
    console.log('iframeData :'+ iframeData );
    window.top.postMessage(iframeData , '*');
  }
  handleMonthChange(intel) {
    this.setState({
      selectedMonth: intel.getMonth(),
      selectedYear: intel.getFullYear()
    });
    dataDays["month"] = intel.getMonth();
    dataDays["year"] = intel.getFullYear();
    this.props.appointementInit('AvailableBookingTimeSlotsForMonth' ,  dataDays , 'dealerDays');
  }
  handleDayClick(day, { selected }) {
    this.setState({
      selectedDay: selected ? undefined : day,
    });

    dataHours["date"] = selected ? undefined : day.getFullYear()+'-'+formatNumber(day.getMonth() + 1)+'-'+formatNumber(day.getDate()) ;

    if(dataHours["date"] !== undefined){
      this.props.appointementInit('AvailableBookingTimeSlotsForDay' ,  dataHours , 'dealerHours');
    }else{
      this.props.appointementClearHours();
    }

  }
  handleClick(event , id, time) {
    let formatNum = moment(dataHours.date).format('Do');
    var dataTime = {
      dayCalendar: dataHours.date+'T'+time+':00+01:00',
      dayLet: upper(moment(dataHours.date).format('dddd')),
      dayNum: formatNum.replace(/\D/g,''),
      month: upper(moment(dataHours.date).format('MMMM')),
      time: time.replace(":", "h")
    }
    event.preventDefault();
    this.props.timeInfo(dataTime);
    this.props.appointementSave(id);
    //TRACKING
    var values = {};
    var type = this.props.inquires.home.type;
    values.eventName = "date-time";
    if(this.props.inquires.home.type=="achat") {
      this.props.inquires[type]['purchaseTime']['leadName']===undefined ? values['purchaseIntent'] = "Less than a month" : values['purchaseIntent'] = this.props.inquires[type]['purchaseTime']['leadName'];
      values['financinge'] = this.props.inquires[type]['financing'];
      values['seatCustomer'] = this.props.inquires[type]['customerSeat'];
      values['licenseRegistration'] = "";
    }
    this.props.inquires[type]['test']=="non" || this.props.inquires[type]['test']==null ? values['testDrive'] = "non" : values['testDrive'] = "oui";
    this.props.inquires[type]['appointment']==null ? values['prefence'] = "" : values['prefence'] = this.props.inquires[type]['appointment'];
    values.modelChoice = this.props.restIntel.intel.dealerInfo.idCar;
    values.dealerChoice = this.props.restIntel.intel.dealerInfo.proFullName;
    values.postalCode = this.props.restIntel.intel.dealerInfo.zipCode;
    values.dateChoice = this.props.restIntel.intel.timeInfo.dayCalendar;
    values.time = this.props.restIntel.intel.timeInfo.time;
    var iframeData = ["setData", values];
    console.log('iframeData :'+ iframeData );
    window.top.postMessage(iframeData , '*');
    console.log(values);
  }
  disableDays(day) {
    var dateToEnable = this.props.restIntel.intel.dealerDays.map(i => {
      return new Date(i);
    });
    return !dateToEnable.some(index =>
      DateUtils.isSameDay(day, index)
    )
  }
  render() {
    var hours = this.props.restIntel.intel.dealerHours;
    var hoursRender = hours.map(i => {
      return (
        <button className="timeCta fontRegular" key={i.id} onClick={e => this.handleClick(e , i.id, i.time)}>{i.time}</button>
      );
    });
    return (
      <div className="moduleMainBodyIntelCalendar">

        <div className="calendarContent">
        <div className="pageFormTitle fontBold colorBlack">Selectionnez un jour</div>
        <DayPicker
          months={MONTHS}
          weekdaysLong={WEEKDAYS_LONG}
          weekdaysShort={WEEKDAYS_SHORT}
          firstDayOfWeek={1}
          locale="fr"
          onMonthChange={this.handleMonthChange}
          captionElement ={(p) => <div className="DayPicker-Caption"><span className="DayPicker-CaptionM">{MONTHS[p.date.getMonth()]}</span> <span className="DayPicker-CaptionY">{p.date.getFullYear()}</span></div>
          }
          // modifiers={modifiers}
          selectedDays={this.state.selectedDay}
          onDayClick={this.handleDayClick}
          month={new Date(actualYear, (actualMonth-1))}
          fromMonth={ actualMonth !== 12 ? new Date( actualYear, actualMonth - 1 ) : new Date( actualYear - 1 , 12 ) }
          disabledDays={this.disableDays}
        />
        </div>
        <div className="timeContent">
          <div className="timeSubContent">
          <div className="pageFormTitle fontBold colorBlack">
          Selectionnez une heure.
          </div>
          <div className="pageSep"/>
            <div className="timeButtonContent">
              {this.props.restIntel.intel.dealerHours.length === 0 ? <div className="pageCalendarHours colorGrey1 fontBook">Selectionnez une date disponible.</div> : hoursRender }
            </div>
        </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      appointementInit,
      stepIncrement,
      appointementClearHours,
      appointementSave,
      timeInfo
    },
    dispatch
  );

export const PageCalendar = connect(mapStateToProps, mapDispatchToProps)(
  ClassCalendar
);



// WEBPACK FOOTER //
// ./src/containers/PageCalendar.js